import { DevLogger as dl } from '@ngcore/core'; import isDL = dl.isLoggable;
// import { DateIdUtil } from '@ngcore/core';
// import * as markdownpdf from 'markdown-pdf';


export namespace CommonPDFxUtil {

  // TBD:
  export function convertToPDF(markdownStr: string, showDebugLog = false): (string | null) {
    if (showDebugLog) {
      if(isDL()) dl.log('CommonPDFxUtil: convertToPDF() with markdownStr = ' + markdownStr);
    }

    // tbd:
    let pdfStr = '';
    // ..

    // markdownpdf().from.string(markdownStr).to.string(null, () => {

    // });



 
    if (showDebugLog) {
      if(isDL()) dl.log('CommonPDFxUtil: convertToPDF() generated pdfStr = ' + pdfStr);
    }
    return pdfStr;
  }

}
